import React from "react";

export default function LiveTvIcon(props: any) {
  return (
    <svg
      width={props?.width || 20}
      height={props?.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.33333 12.1472L12.9808 9.16634L8.33333 6.18551V12.1472ZM7.5 16.6663V14.9997H3.84667C3.46278 14.9997 3.1425 14.8713 2.88583 14.6147C2.62917 14.358 2.50056 14.0375 2.5 13.653V4.67967C2.5 4.29579 2.62861 3.97551 2.88583 3.71884C3.14306 3.46217 3.46306 3.33356 3.84583 3.33301H16.1542C16.5375 3.33301 16.8575 3.46162 17.1142 3.71884C17.3708 3.97606 17.4994 4.29634 17.5 4.67967V13.6538C17.5 14.0372 17.3714 14.3575 17.1142 14.6147C16.8569 14.8719 16.5369 15.0002 16.1542 14.9997H12.5V16.6663H7.5ZM3.84667 14.1663H16.1542C16.2819 14.1663 16.3994 14.113 16.5067 14.0063C16.6139 13.8997 16.6672 13.7819 16.6667 13.653V4.67967C16.6667 4.55134 16.6133 4.43356 16.5067 4.32634C16.4 4.21912 16.2825 4.16579 16.1542 4.16634H3.84583C3.71806 4.16634 3.60056 4.21967 3.49333 4.32634C3.38611 4.43301 3.33278 4.55079 3.33333 4.67967V13.6538C3.33333 13.7816 3.38667 13.8991 3.49333 14.0063C3.6 14.1136 3.7175 14.1669 3.84583 14.1663"
        fill={props?.color || "#666666"}
      />
    </svg>
  );
}
